<template>
  <div class='gsdt_con gsdt_detail'>
    <div class='pub_top_block w_1200'>
      <img v-if='device == "mobile"' :src='detailObj.cover_picture' alt='新闻图' class='bg'>
      <dl>
        <dt>
          <h3>{{ detailObj.title }}</h3>
          <div class='text'>
            {{ detailObj.summary }}
          </div>
        </dt>
      </dl>
      <img v-if='device != "mobile"' :src='detailObj.cover_picture' alt='新闻图' class='bg'>
    </div>
    <div class='info_box w_1200'>
      <div class='tit'>{{ detailObj.date }}，{{ $t('about.news.title') }}</div>
      <div class='info'>
        <html-content :html='detailObj.content'></html-content>
      </div>
    </div>
  </div>
</template>

<script>
import { setTitle, mediaDevice } from 'utils'
import { getNewsDetailById } from '@/service'
import HtmlContent from '@/components/HtmlContent'

export default {
  name: 'CompanyNewsDetail',
  components: {
    HtmlContent,
  },
  data () {
    return {
      detailObj: {},
      device: mediaDevice(),
    }
  },
  mounted () {
    let id = this.$route.params.id
    this.getDetailInfo(id)
    window.addEventListener('resize', () => {
      this.device = mediaDevice()
    })
  },
  beforeMount () {
    setTitle(`${this.$t('home.logo')} - ${this.$t('about.news.title')}`)
  },
  methods: {
    getDetailInfo (id) {
      getNewsDetailById(id).then(res => {
        this.detailObj = res.data
      })
    },
  },
}
</script>
